import NetworkTest from 'opentok-network-test-js';
import OT from '@opentok/client';
import { estimate } from 'providers/video/common/lib/doxyme-opentok-mos';
import bowser from 'bowser';

export default angular
  .module('doxy.account.common.services.opentokTestService', [])
  .service(
    'opentokTestService',
    function ($injector, $rootScope, tokboxConfig) {
      function initNetworkTest(options = {}) {
        /*
        We have a lot of complaints (Ipad, Android) about problems with camera.
        Have to disable it completely and investigate
      */
        return;
        /*
         Here is an issue on IOS:

         iOS. After patient check-in - Cam preview is displayed for 1 sec and disabled.
         Cam is blocked, icon in address line is changed from cam to mic.
         When call is started Cam is disabled and Enable Cam button is displayed.

         Issue with iPad: when in the "Request desktop website" mode - it is detected as desktop safari
         while actually being the mobile platform and it fails the same way
       */
        if (bowser.safari) return;

        _createTestChannel().then((result) => {
          if (!result.token) return false;

          const networkTestInstance = new NetworkTest(
            OT,
            {
              apiKey: tokboxConfig.apiKey,
              sessionId: result.channel,
              token: result.token,
            },
            options
          );

          _startTesting(networkTestInstance);
        });
      }

      function _getRoomResource() {
        return $injector.get('Room');
      }

      function _createTestChannel() {
        return _getRoomResource().createTestingChannel().$promise;
      }

      function _startTesting(testingProvider) {
        if (!testingProvider) return false;
        testingProvider
          .testConnectivity()
          .then((r) => {
            testingProvider
              .testQuality(function updateCallback(stats) {})
              .then((results) => {
                const data = { ...results };
                if (data.video.supported && data.audio.supported) {
                  data.score = (results.audio.mos + results.video.mos) / 2;
                } else if (data.video.supported) {
                  data.score = results.video.mos;
                } else {
                  data.score = results.audio.mos;
                }
                estimate(data);
                $rootScope.$emit('opentokTestService:qualityResults', data);
                console.log('OpenTok quality results', data);
              })
              .catch((error) => {
                console.log('OpenTok quality test error', error);
              });
          })
          .catch(function (error) {
            console.log('OpenTok connectivity test error', error);
          });
      }

      return {
        initNetworkTest: initNetworkTest,
      };
    }
  ).name;
